import { FC, useState } from 'react';

import { Registration } from '../../../../types/registrationTypes';
import useIsMounted from '../../../../hooks/useIsMounted';
import LocationForm from './containers/locationForm';
import {useCurrentPartner} from "../../hooks/useCurrentPartner";

interface Props {
  registration?: Registration | null;
  defaultCountry: string;
  updateRegistration: (registration: Registration) => Promise<Registration>;
  preventSwitchTabDueToUnsavedData: (value: boolean) => void;
  disabled: boolean;
}

const RegistrationLocation: FC<Props> = ({ registration, defaultCountry, updateRegistration, preventSwitchTabDueToUnsavedData, disabled }) => {
  const [loading, setLoading] = useState<boolean>(false);
  const isMounted = useIsMounted();

  const partnerSalesMarket = useCurrentPartner().market;

  const updateLocation = async (locationData: Registration['location']) => {
    if (!registration?.id) return;
    setLoading(true);
    try {
      await updateRegistration({
        ...registration,
        location: locationData
      });
    } catch (error) {
      throw error;
    } finally {
      if (isMounted) {
        setLoading(false);
      }
    }
  };

  return (
    <LocationForm
      registration={registration}
      defaultCountry={defaultCountry}
      updateLocation={updateLocation}
      loading={loading}
      preventSwitchTabDueToUnsavedData={preventSwitchTabDueToUnsavedData}
      salesMarketForActivePartner={partnerSalesMarket}
      disabled={disabled}
    />
  );
};

export default RegistrationLocation;
